import { render, staticRenderFns } from "./IconsGrid.vue?vue&type=template&id=080a076a&scoped=true"
import script from "./IconsGrid.vue?vue&type=script&lang=js"
export * from "./IconsGrid.vue?vue&type=script&lang=js"
import style0 from "./IconsGrid.vue?vue&type=style&index=0&id=080a076a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080a076a",
  null
  
)

export default component.exports